import { render, staticRenderFns } from "./employerpage.vue?vue&type=template&id=f984d962&scoped=true&"
import script from "./employerpage.vue?vue&type=script&lang=js&"
export * from "./employerpage.vue?vue&type=script&lang=js&"
import style0 from "./employerpage.vue?vue&type=style&index=0&id=f984d962&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f984d962",
  null
  
)

export default component.exports